module.exports = function (nunjucks, env, obj, dependencies){

    var oldRoot = obj.root;

    obj.root = function( env, context, frame, runtime, ignoreMissing, cb ) {
        var oldGetTemplate = env.getTemplate;
        env.getTemplate = function (name, ec, parentName, ignoreMissing, cb) {
            if( typeof ec === "function" ) {
                cb = ec = false;
            }
            var _require = function (name) {
                try {
                    // add a reference to the already resolved dependency here
                    return dependencies[name];
                }
                catch (e) {
                    if (frame.get("_require")) {
                        return frame.get("_require")(name);
                    }
                    else {
                        console.warn('Could not load template "%s"', name);
                    }
                }
            };

            var tmpl = _require(name);
            frame.set("_require", _require);

            if( ec ) tmpl.compile();
            cb( null, tmpl );
        };

        oldRoot(env, context, frame, runtime, ignoreMissing, function (err, res) {
            env.getTemplate = oldGetTemplate;
            cb( err, res );
        });
    };

    var src = {
        obj: obj,
        type: 'code'
    };

    return new nunjucks.Template(src, env);

};


//////////////////
// WEBPACK FOOTER
// ./~/nunjucks-loader/runtime-shim.js
// module id = 4
// module chunks = 2 3 4 5 50 51 52 53 54 57 58 59 60 61 62 63 64 65 66 67